const siap = {
  GetPersonas: 'SIAP/GetPersonas',
  GetPersona: 'SIAP/GetPersona',
  GetPersonaPorId: 'SIAP/GetPersonaPorId',
  GetTipoEstadoCivil: 'SIAP/GetTipoEstadosCiviles',
  SetActivoPersona: 'SIAP/SetActivoPersona',
  GetSolicitudes: 'SIAP/GetSolicitudes',
  GetSolicitud: 'SIAP/GetSolicitud',
  GetHistorialLaboral: 'SIAP/GetHistorialLaboral',
  GetHistorialLaboral2: 'SIAP/GetHistorialLaboral2',
  CrearSolicitud: 'SIAP/CrearSolicitud',
  ActualizarSolicitud: 'SIAP/ActualizarSolicitud',
  CrearSolicitud: 'SIAP/CrearSolicitud',
  GuardarDatosPersonales: 'SIAP/GuardarDatosPersonales',
  GuardarDatosAcademicos: 'SIAP/GuardarDatosAcademicos',
  GuardarDatosLaborales: 'SIAP/GuardarDatosLaborales',
  GuardarDatosSuperiores: 'SIAP/GuardarDatosJefesSuperiores',
  GuardarDatosFamiliares: 'SIAP/GuardarDatosFamiliares',
  GuardarImagen: 'SIAP/GuardarImagen',
  MigracionSIAP: 'SIAP/MigracionSIAP',
  MigrarPuestosPJ: 'SIAP/MigrarPuestosPJ',
  MigrarPersonasSIAP: 'SIAP/MigrarPersonasSIAP',
  MigrarDomicilios: 'SIAP/MigrarDomicilios',
  AgregarHistorialMigracion: 'SIAP/AgregarHistorialMigracion',
  AsignarEstructuraOrganica: 'SIAP/AsignarEstructuraOrganica',
  MigrarFamiliares: 'SIAP/MigrarFamiliares',
  MigrarHistorialLaboral: 'SIAP/MigrarHistorialLaboral',
  MigrarEstructurasOrganicas: 'SIAP/MigrarEstructurasOrganicas',
  CopiarRegistroHistorialLaboralmonteRH: 'SIAP/CopiarRegistroHistorialLaboralmonteRH',
  BuscarPersonaPorArea: 'SIAP/BuscarPersonaPorArea',
  ActualizarEstructuraOrganicaPersonas: 'SIAP/ActualizarEstructuraOrganicaPersonas',
  GenerarContrasenasAleatorias: 'SIAP/GenerarContrasenasAleatorias',
  AsignarSuperiores: 'SIAP/AsignarSuperiores',
  GetColaboradores: 'SIAP/GetColaboradores',
  GetEvaluaciones: 'SIAP/GetEvaluaciones',
  GuardarComentarioEvaluacion: 'SIAP/GuardarComentarioEvaluacion',
  ExistePersona: 'SIAP/ExistePersona',
  GuardarEstructuraOrganica: 'SIAP/GuardarEstructuraOrganica',
  GetEstructurasOrganicas: 'SIAP/GetEstructurasOrganicas',
  GuardarFechaFinalComoSuperior: 'SIAP/GuardarFechaFinalComoSuperior',
  GetBecarios: 'SIAP/GetBecarios',
  GetPersonasReportePersonal: 'SIAP/GetPersonasReportePersonal',
  GetOrganigrama: 'SIAP/GetOrganigrama',
  GetOrganigrama2: 'SIAP/GetOrganigrama2',
  GetOrganigramaConFoto: 'SIAP/GetOrganigramaConFoto',
  EditarPeriodoEvaluacion: 'SIAP/EditarPeriodoEvaluacion',
  GetImagenDeRostroBase64: 'SIAP/GetImagenDeRostroBase64',
  GetHistorialDeEstructuraOrganica: 'SIAP/GetHistorialDeEstructuraOrganica',
  ObtenerNombramientos: 'SIAP/ObtenerNombramientos',
  ObtenerPersonas: 'SIAP/ObtenerPersonas',
  ObtenerNombramientosPorPersona: 'SIAP/ObtenerNombramientosPorPersona',
  ObtenerNombramientoPorId: 'SIAP/ObtenerNombramientoPorId',
  GuardarNombramiento: 'SIAP/GuardarNombramiento',
  GuardarFirmaAutografa: 'SIAP/GuardarFirmaAutografa',
  GetImagenFirmaAutografaBase64: 'SIAP/GetImagenFirmaAutografaBase64',
  AgregarNuevoPuesto: 'SIAP/AgregarNuevoPuesto',
  CambiarEstatusDeEntregaNombramiento: 'SIAP/CambiarEstatusDeEntregaNombramiento',
  ListadoIncidenciasPersonal: 'SIAP/Incidencias/ListadoIncidenciaPersonal',
  NuevaIncidencia: 'SIAP/Incidencias/Nueva',
  CambiaEstatusIncidencia: 'SIAP/Incidencias/ActualizaEstatusIncidencia',
  GenerarPlantilla: 'SIAP/Incidencias/CreaPlantilla',
  VerificarUsuario: 'SIAP/Incidencias/VerificarTitularArea',
  NombramientosPorFeecha: 'SIAP/Nombramientos/GetNombramientosPorFecha',
  ObtenerTiposPlantillasDeNombramientos: 'SIAP/Catalogos/GetTiposPlantillasDeNombramientos',
  GenerarPlantillaDeNombramiento: 'SIAP/Nombramientos/GetGenerarPlantillaDeNombramiento',
  GuardarDocumentoIncidencia: 'SIAP/Incidencias/SubirDigital',
  ModificarIncidencia: 'SIAP/Incidencias/EditaIncidenciaFechas',
  GetReporteInterinatos: 'SIAP/GetReporteInterinatos',
  ExpotarDocumentoChecador : 'SIAP/Checador/ObtenerExcelRegistros',
  PreNomina : 'SIAP/Checador/PreNomina',
  EventosCalendarioChecador: 'SIAP/Checador/EventosCalendario',
  ValidaChecado: 'SIAP/Checador/ValidaRegistro',
  AsistenciasCalendarioChecador : 'SIAP/Checador/AsistenciasCalendario',
  ImportarDatos : 'SIAP/Importacion/ObtenerExcelRegistros',
  BajasDePersonal : 'SIAP/Importacion/BajasDePersonal',
  MovimientosDePersonal : 'SIAP/Importacion/MovimientosDePersonal',
  AltasDePersonal : 'SIAP/Importacion/AltasDePersonal'
}
export default siap;



//////////////////
// WEBPACK FOOTER
// ./static/js/api/siap/funcion/siap.js
// module id = null
// module chunks = 